import { TFunction } from "i18next";

import { CostTreeNode } from "@rossum/upcloud-costs-shared";

/** Display name of a cost tree node: translated for unassigned and category nodes. */
export function nodeLabel(node: CostTreeNode, t: TFunction): string {
    switch (node.kind) {
        case "ROOT":
            return t("costTree.total");
        case "TENANT":
            return node.code ?? t("costTree.unassignedTenant");
        case "SERVICE":
            return node.code ?? t("costTree.unassignedService");
        case "CATEGORY":
            return t(`category.${node.code ?? ""}`, { defaultValue: node.code ?? "" });
        case "RESOURCE":
            return node.label ?? node.cloudResourceId ?? "";
    }
}
